import $ from 'jquery'
import EventEmitter from 'eventemitter3'
import Pristine from 'pristinejs'

export default class NewsletterFormController {
  constructor (element, options) {
    this._element = element
    this._settings = $.extend({}, options)
    this._eventEmitter = new EventEmitter()
    this._triedSubmit = false
    this._initValidator()
    this._bindUIActions()
  }

  _initValidator () {
    if (this._pristine) this._pristine.destroy()
    this._pristine = new Pristine(this._element, {
      // class of the parent element where the error/success class is added
      classTo: 'form__input-container',
      errorClass: 'form__input-container--has-danger',
      successClass: 'form__input-container--has-success',
      // class of the parent element where error text element is appended
      errorTextParent: 'form__input-container',
      // type of element to create for the error text
      errorTextTag: 'div',
      // class of the error text element
      errorTextClass: 'form__input-container__text-help'
    })
  }

  prefillEmail (email) {
    $(this._element)
      .find('.newsletter-form__input--email')
      .val(email)

    const message = 'Just a few more details.'
    $(this._element)
      .find('.form__messages')
      .html($('<div class="form__messages__item">' + message + '</div>'))

    if (this._triedSubmit) {
      this._pristine.validate()
    }
  }

  focusFirst () {
    const $emailInput = $(this._element).find('.newsletter-form__input--email')
    const emailVal = $emailInput.val()

    if (emailVal) {
      const $firstNameInput = $(this._element).find(
        '.newsletter-form__input--first-name'
      )
      $firstNameInput.focus()
    } else {
      $emailInput.focus()
    }
  }

  _disableForm () {
    $(this._element).addClass('form--disabled')
    $(this._element)
      .find('.form__input')
      .prop('disabled', 'true')
    $(this._element)
      .find('.form__submit-button')
      .prop('disabled', 'true')
  }

  _enableForm () {
    // Caution: if fields were disabled for another reason, they will be enabled anyway. Use with caution and adjust when needed.
    $(this._element).removeClass('form--disabled')
    $(this._element)
      .find('.form__input')
      .prop('disabled', null)
    $(this._element)
      .find('.form__submit-button')
      .prop('disabled', null)
  }

  _showFeedback (html, scroll = false) {
    $(this._element)
      .find('.form__messages')
      .html(html)

    if (scroll) {
      this._scrollToFeedback()
    }
  }

  _scrollToFeedback () {
    let scrollContainer = $(this._element).closest(
      '.newsletter-form-scroll-container'
    )[0]
    if (!scrollContainer) scrollContainer = document.documentElement

    $(scrollContainer).animate(
      {
        scrollTop: 0
      },
      300
    )

    // const messagesElement = $(this._element).find('.form__messages')[0]

    // const newScrollTop = messagesElement.offsetTop - scrollContainer.offsetTop

    // if (messagesElement) {
    //   $(scrollContainer).animate(
    //     {
    //       scrollTop: newScrollTop
    //     },
    //     300
    //   )
    // }
  }

  _buildValidationErrorFeedback (resp) {
    // create errors output
    return (
      '<div class="form__messages__item__box form__messages__item__box--error form__messages__item__box--highlight-appearance"><p>' +
      resp.msg +
      '</p></div>'
    )
  }

  _buildForgottenEmailErrorFeedback () {
    const template = $('#template-newsletter-error-forgotten-email').html()
    return template
  }

  _buildUnknownErrorFeedback () {
    const template = $('#template-newsletter-error').html()
    return template
  }

  _getAjaxSubmitUrl () {
    var url = $(this._element).attr('action')
    url = url.replace('/post?u=', '/post-json?u=')
    url += '&c=?'
    return url
  }

  _trySubmit () {
    this._triedSubmit = true

    const valid = this._pristine.validate() // returns true or false

    if (valid) {
      const serialized = $(this._element).serializeArray()
      const dataObj = serialized.reduce((obj, entry) => {
        obj[entry.name] = entry.value
        return obj
      }, {})

      this._disableForm()
      const postUrl = this._getAjaxSubmitUrl()

      $.get(
        postUrl,
        dataObj,
        data => {},
        'json' // I expect a JSON response
      )
        .done(data => {
          if (data.result === 'success') {
            this._enableForm()
            this._eventEmitter.emit('submitted')
          } else {
            if (data.msg === 'captcha') {
              var url = $(this._element).attr('action')
              var parameters = $.param(data.params)
              url = url.split('?')[0]
              url += '?'
              url += parameters
              window.open(url)
            }

            const errorHtml = this._buildValidationErrorFeedback(data)
            this._showFeedback(errorHtml, true)
            this._enableForm()
          }
        })
        .fail(jqXHR => {
          // const data = jqXHR.responseJSON
          this._showFeedback(this._buildUnknownErrorFeedback(), true)

          // Enable the form again
          this._enableForm()
        })
    }
  }

  onSubmitted (callback) {
    this._eventEmitter.on('submitted', callback)
  }

  offSubmitted (callback) {
    this._eventEmitter.removeListener('submitted', callback)
  }

  _updateCompanyVisibility () {
    const $contactType = $(this._element).find(
      '.newsletter-form__contact-type'
    )
    const $contactTypeChosenInput = $($contactType).find('input:checked')

    const $company = $(this._element).find('.newsletter-form__company')
    if (
      $contactTypeChosenInput.length === 0 ||
      $contactTypeChosenInput[0].hasAttribute('data-no-company')
    ) {
      $company.hide()
      // $company.find('.form__input').attr('required', null)
    } else {
      $company.show()
      // $company.find('.form__input').attr('required', '1')
    }

    // If the validation is active, re-initialize it, because specific brands 'min' validation attribute might have changed (see above)
    this._initValidator()
    if (this._triedSubmit) {
      this._pristine.validate()
    }
  }

  _bindUIActions () {
    this._updateCompanyVisibility()

    const $contactType = $(this._element).find(
      '.newsletter-form__contact-type'
    )
    $($contactType)
      .find('input')
      .on('change', () => {
        this._updateCompanyVisibility()
      })

    $(this._element).submit(e => {
      try {
        this._trySubmit()
      } catch (e) {}
      return false
    })
  }
}
